import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { PopupsService } from '../services/popups.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

const USER_MESSAGES: { [key: number]: string } = {
  400: 'Invalid request. Please check the information you entered.',
  401: 'Your session has expired. Please log in again.',
  403: 'You do not have permission to perform this action.',
  404: 'The requested resource does not exist.',
  500: 'Internal server error.',
  503: 'This service is temporarily unavailable, Please try again later.'
};

export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  if (!req.url.includes(environment.APIEndpoint)) {
    return next(req);
  }

  const popupsSrv = inject(PopupsService);
  const translate = inject(TranslateService);
  const authSrv = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      
      if (!environment.production) {
        console.error('Error log: ', {
          status: error.status,
          message: error.message,
          url: error.url
        });
      }

      let errorMessage = USER_MESSAGES[error.status] || translate.instant('UnexpectedErrorOcurred');

      if (error.status === 401) {
        authSrv.logOut();
      }

      console.error(errorMessage);

      popupsSrv.presentToast(errorMessage, 5000, 'middle');

      return throwError(() => ({
        status: error.status,
        message: errorMessage
      }));
    })
  );
}